import { Box, styled } from '@mui/material';

export const DottedTitleStyled = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'max-content 1fr',
  alignItems: 'center',
  width: '100%',
}));
